import {
    FETCH_DEVICE_BETA_SOFTWARE_INFO_FETCHING,
    FETCH_DEVICE_BETA_SOFTWARE_INFO_SUCCESS,
    FETCH_DEVICE_BETA_SOFTWARE_INFO_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    deviceBetaSoftwareInfo: {},
    deviceBetaSoftwareInfoFetching: false,
    deviceBetaSoftwareInfoFetchFail: false
};

// ======= Fetching Handlers =======
const deviceBetaSoftwareInfoFetching = (state) => {
    return {
        ...state,
        deviceBetaSoftwareInfoFetching: true,
        deviceBetaSoftwareInfoFetchFail: false
    };
};

const deviceBetaSoftwareInfoFetchSuccess = (state, action) => {
    return {
        ...state,
        deviceBetaSoftwareInfo: {
            ...state.deviceBetaSoftwareInfo,
            [action.deviceId]: {
                ...action.data
            }
        },
        deviceBetaSoftwareInfoFetching: false,
        deviceBetaSoftwareInfoFetchFail: false
    };
};

const deviceBetaSoftwareInfoFetchFail = (state) => {
    return {
        ...state,
        deviceBetaSoftwareInfoFetching: false,
        deviceBetaSoftwareInfoFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DEVICE_BETA_SOFTWARE_INFO_FETCHING]: deviceBetaSoftwareInfoFetching,
    [FETCH_DEVICE_BETA_SOFTWARE_INFO_SUCCESS]: deviceBetaSoftwareInfoFetchSuccess,
    [FETCH_DEVICE_BETA_SOFTWARE_INFO_FAIL]: deviceBetaSoftwareInfoFetchFail
};

// ======= Default Action =======
export default function deviceBetaSoftwareInfo(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getDeviceBetaSoftwareInfo = (state) => {
    return state.deviceBetaSoftwareInfo?.deviceBetaSoftwareInfo
        ? state.deviceBetaSoftwareInfo?.deviceBetaSoftwareInfo
        : null;
};

export const isDeviceBetaSoftwareInfoFetching = (state) => {
    return state.deviceBetaSoftwareInfo?.deviceBetaSoftwareInfoFetching;
};

export const didDeviceBetaSoftwareInfoFail = (state) => {
    return state.deviceBetaSoftwareInfo?.deviceBetaSoftwareInfoFetchFail;
};
